import { render } from "./user-settle-trades-app.vue?vue&type=template&id=71a78560"
import script from "./user-settle-trades-app.vue?vue&type=script&lang=js"
export * from "./user-settle-trades-app.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__